import { bindActionCreators, Dispatch } from 'redux';
import { isDirty, reset, getFormValues, getFormSyncErrors, isValid, touch } from 'redux-form';
import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as operationSelectors, actions as operationActions } from 'ducks/uiOperations';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import { selectors as formSelectors } from 'ducks/form';
import {
    selectors as jobTemplateSelectors,
} from 'ducks/jobTemplateMaintenance/jobTemplate';
import {
    selectors as activitySelectors,
    actions as activityActions
} from 'ducks/jobTemplateMaintenance/activity';

import Activities from './Activities';

const FORM_NAME = 'Activities';

const mapStateToProps = (state: IApplicationState) => ({
    isValid: isValid(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
    formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
    operationMode: operationSelectors.operationMode(state),
    selectedTab: uiSelectors.selectedTab(state),
    selectedForm: formSelectors.selected(state),
    isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
    activityData: activitySelectors.activityData(state),
    formData: activitySelectors.formData(state),
    selectedJobTemplate: jobTemplateSelectors.selected(state),
    selectedActivity: activitySelectors.selected(state),
    selectedActivitySchema: activitySelectors.selectedSchema(state),
    isFormLoading: activitySelectors.isFormLoading(state),
    ServiceItemTypeId: jobTemplateSelectors.ServiceItemTypeId(state),
    dirty: isDirty(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        resetForm: () => reset(FORM_NAME),
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeOperationMode: operationActions.changeOperationMode,
        addActivity: activityActions.create,
        deleteActivity: activityActions.delete,
        fetchActivityData: activityActions.fetchActivityData,
        resetFormData: activityActions.resetFormData,
        resetActivityData: activityActions.resetActivityData,
        setSelectedActivity: activityActions.setSelected,
        updateActivity: activityActions.updateActivity,
        touchFormFields: (...args: any) => touch(FORM_NAME, ...args),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Activities);
